import { createRouter, createWebHistory } from 'vue-router';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import store from '@/store';

const routes = [
  {
    path: '/login', // Login route should be first
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: 'เข้าสู่ระบบ',
    },
  },
  {
    path: '/', // Root path redirects to dashboard, but only if logged in
    name: 'Apps',
    component: DefaultLayout,
    redirect: '/dashboard', // Default redirect to dashboard
    meta: {
      requiresAuth: true, // Protect this section
      roles: ['admin', 'manager', 'user'],
    },
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: {
          title: 'หน้าหลัก',
        },
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/Profile.vue'),
        meta: {
          title: `Profile`
        }
      },
      {
        path: '/test',
        name: 'Test',
        component: () => import('@/views/Test.vue'),
        meta: {
          title: 'Test',
        },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Router Guard to handle authentication and role-based access control
router.beforeEach((to, from, next) => {
  // Set document title dynamically
  document.title = `${to.meta.title} | ${store.state.projectName || 'Default Project Name'}`;

  // Check if the route requires authentication and if the user is logged in
  const isAuthenticated = !!localStorage.getItem('token'); // Check for token
  if (to.meta.requiresAuth && !isAuthenticated) {
    // If the user is not authenticated, redirect to login page
    return next({ name: 'Login' }); // Redirect to the login page
  }

  // Check for role-based access control
  const userRoles = store.state.role || []; // Get user roles from the store
  const requiredRoles = to.meta.roles;

  if (requiredRoles && !requiredRoles.some(role => userRoles.includes(role))) {
    // If user doesn't have the required role, redirect to dashboard
    return next({ name: 'Dashboard' });
  }

  next(); // Proceed to the route
});

export default router;
